export default __webpack_public_path__ + "static/media/Footpad's Boots of the Nadir.d6d0ab82.jpg";